import apiUrl from './api';
import { postWithAuth } from '@/lib/httpAdapter';

export interface CreateTeamRequest {
  OrgUUID: string;
  TeamName: string;
}

export async function createTeam(request: CreateTeamRequest) {
  const endpoint = `${apiUrl}createTeam/`;

  try {
    const response = await postWithAuth(endpoint, request);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    // Parse if response is a string
    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch (parseError) {
        console.error(
          'Failed to parse createTeam response string:',
          parseError
        );
        return data;
      }
    }

    return data;
  } catch (error) {
    console.error('Error creating team:', error);
    return {
      Error: error instanceof Error ? error.message : 'Failed to create team',
    };
  }
}
